webpackJsonp([183328146348521],{

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _siteMetadata = __webpack_require__(72);
	
	var _Page = __webpack_require__(108);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _theme = __webpack_require__(218);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _NotFoundMessage = __webpack_require__(504);
	
	var _NotFoundMessage2 = _interopRequireDefault(_NotFoundMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Currently no theme is supplied to styled components in the 404 page so we
	// need to do it explicitly here by wrapping it in a ThemeProvider.
	var FourOhFourPage = function FourOhFourPage(props) {
	  return _react2.default.createElement(
	    _styledComponents.ThemeProvider,
	    { theme: _theme2.default },
	    _react2.default.createElement(
	      _Page2.default,
	      { title: (0, _siteMetadata.FourOhFourPageTitle)(props.data) },
	      _react2.default.createElement(_NotFoundMessage2.default, { path: props.location.pathname })
	    )
	  );
	};
	
	FourOhFourPage.propTypes = {
	  location: _propTypes2.default.object.isRequired,
	
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = FourOhFourPage;
	module.exports = exports['default'];

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['s:giant'], ['s:giant']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['-1ru'], ['-1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _StarLogo = __webpack_require__(543);
	
	var _StarLogo2 = _interopRequireDefault(_StarLogo);
	
	var _HLayout = __webpack_require__(111);
	
	var _HLayout2 = _interopRequireDefault(_HLayout);
	
	var _VLayout = __webpack_require__(19);
	
	var _VLayout2 = _interopRequireDefault(_VLayout);
	
	var _TextLink = __webpack_require__(33);
	
	var _TextLink2 = _interopRequireDefault(_TextLink);
	
	var _spinOnYAxis = __webpack_require__(551);
	
	var _spinOnYAxis2 = _interopRequireDefault(_spinOnYAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Four = _styledComponents2.default.div.withConfig({
	  displayName: 'NotFoundMessage__Four'
	})(['']);
	var LogoWrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'NotFoundMessage__LogoWrapper'
	})(['']);
	
	var Header = (0, _styledComponents2.default)(_HLayout2.default.withComponent('header')).withConfig({
	  displayName: 'NotFoundMessage__Header'
	})(['animation:', ' 3s cubic-bezier(0.165,0.84,0.44,1);align-items:center;', ';'], (0, _spinOnYAxis2.default)(3), (0, _cssapi.api)({
	  baseline: (0, _cssapi.scope)(_templateObject),
	  fontWeight: 600,
	  fontFamily: 'f:title',
	  marginH: 'auto'
	}));
	
	var Layout = (0, _styledComponents2.default)(_VLayout2.default).attrs({ spacing: 'large' }).withConfig({
	  displayName: 'NotFoundMessage__Layout'
	})(['text-align:center;', '{position:relative;', ';}'], LogoWrapper, (0, _cssapi.api)({
	  width: [90, 150],
	  top: (0, _cssapi.scope)(_templateObject2)
	}));
	
	var Body = _styledComponents2.default.div.withConfig({
	  displayName: 'NotFoundMessage__Body'
	})(['']);
	
	var NotFoundMessage = function NotFoundMessage(_ref) {
	  var path = _ref.path;
	  return _react2.default.createElement(
	    Layout,
	    { spacing: 'large' },
	    _react2.default.createElement(
	      Header,
	      { spacing: 'none' },
	      _react2.default.createElement(
	        Four,
	        null,
	        '4'
	      ),
	      _react2.default.createElement(
	        LogoWrapper,
	        null,
	        _react2.default.createElement(_StarLogo2.default, null)
	      ),
	      _react2.default.createElement(
	        Four,
	        null,
	        '4'
	      )
	    ),
	    _react2.default.createElement(
	      Body,
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'There was no page at that address.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Would you like to go to the ',
	        _react2.default.createElement(
	          _TextLink2.default,
	          { to: '/' },
	          'Home page'
	        ),
	        '?'
	      )
	    )
	  );
	};
	
	NotFoundMessage.propTypes = {
	  path: _propTypes2.default.string.isRequired
	};
	
	exports.default = NotFoundMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FourOhFourPage = __webpack_require__(503);
	
	var _FourOhFourPage2 = _interopRequireDefault(_FourOhFourPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _FourOhFourPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _fixAspectRatio = __webpack_require__(216);
	
	var _fixAspectRatio2 = _interopRequireDefault(_fixAspectRatio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _styledComponents2.default.div.withConfig({
	  displayName: 'StarLogo__Layout'
	})(['', ';#logoGrad{.gradientStart{', ';}.gradientEnd{', ';}}svg path{fill:url(#logoGrad);}'], (0, _fixAspectRatio2.default)(242, 134), (0, _cssapi.api)({
	  color: 'c:backgroundInverted'
	}), (0, _cssapi.api)({
	  color: 'c:backgroundInverted'
	}));
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      'svg',
	      {
	        version: '1.1',
	        xmlns: 'http://www.w3.org/2000/svg',
	        xmlnsXlink: 'http://www.w3.org/1999/xlink',
	        x: '0px',
	        y: '0px',
	        preserveAspectRatio: 'xMinYMin meet',
	        xmlSpace: 'preserve',
	        viewBox: '0 0 1500 1500',
	        fillRule: 'nonzero'
	      },
	      _react2.default.createElement(
	        'title',
	        null,
	        'Skull Logo'
	      ),
	      _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'linearGradient',
	          { id: 'logoGrad' },
	          _react2.default.createElement('stop', { offset: '0', className: 'gradientStart' }),
	          _react2.default.createElement('stop', { offset: '1', className: 'gradientEnd' })
	        )
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', {
	          className: 'st0',
	          d: 'M750,74.1c0-0.2,0-0.3,0-0.3S750,73.9,750,74.1L750,74.1z'
	        }),
	        _react2.default.createElement('path', {
	          className: 'st1',
	          d: 'M750,73.8L750,73.8L750,73.8L750,73.8L750,73.8z'
	        }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M747.7,0L747.7,0L747.7,0L747.7,0z' }),
	        _react2.default.createElement('path', {
	          className: 'st1',
	          d: 'M750,73.8C749.9,73.8,749.9,73.8,750,73.8L750,73.8C749.9,73.8,749.9,73.8,750,73.8L750,73.8z'
	        }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M747.8,0L747.8,0L747.8,0L747.8,0z' }),
	        _react2.default.createElement('path', {
	          className: 'st1',
	          d: 'M747.9,0L747.9,0C748,0,748,0,747.9,0C748,0,748,0,747.9,0z'
	        }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M747.6,0L747.6,0L747.6,0L747.6,0z' }),
	        _react2.default.createElement('path', { className: 'st1', d: 'M747.4,0L747.4,0L747.4,0L747.4,0z' }),
	        _react2.default.createElement('path', {
	          className: 'st1',
	          d: 'M747.7,0C747.6,0,747.6,0,747.7,0C747.6,0,747.6,0,747.7,0L747.7,0z'
	        })
	      ),
	      _react2.default.createElement(
	        'g',
	        null,
	        _react2.default.createElement('path', { d: 'M1494,916.4c-190.1,25.6-355.9,60.8-497.5,105.7c62.4,72.1,101.1,140.3,115.9,204.7c-16.2,57.7-41,103.7-74.4,138.2 c-33.4,34.5-81.6,67.3-144.6,98.5c-54.3-86.9-134.7-191.4-241.3-313.6c-142.1,66-265.9,141.1-371.3,225.1 c-77.9-61.4-118.2-149.4-121-264.1c66-78.3,150.2-149.9,252.6-214.9C243.1,725,107.6,607.6,6,543.5 c94.1-216.7,231-316.2,410.7-298.8c53.1,72.9,115.3,169.6,186.5,290.2c19.6-128.3,28.9-294.4,27.9-498.3 c86.7-0.4,173.6,14.5,260.6,44.6s153,76.1,198.2,137.9c-41.1,123.1-94,258.9-158.8,407.5c202.8-97,307.6-146.9,314.4-149.9 C1411,575.2,1493.8,721.7,1494,916.4z'
	        })
	      )
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']);
	
	var _cssapi = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _flexHorizontal = __webpack_require__(54);
	
	var _flexHorizontal2 = _interopRequireDefault(_flexHorizontal);
	
	var _spaceChildrenH = __webpack_require__(55);
	
	var _spaceChildrenH2 = _interopRequireDefault(_spaceChildrenH);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var spacingMap = {
	  default: '1ru',
	  tiny: '0.25ru',
	  small: '0.5ru',
	  large: '2ru',
	  smallInverse: '-0.5ru',
	  none: 0
	};
	
	var HLayout = _styledComponents2.default.div.withConfig({
	  displayName: 'HLayout'
	})(['', ';', ';'], _flexHorizontal2.default, function (p) {
	  return (0, _spaceChildrenH2.default)((0, _cssapi.scope)(_templateObject, spacingMap[p.spacing]))(p);
	});
	
	HLayout.propTypes = {
	  spacing: _propTypes2.default.oneOf(['default', 'small', 'large', 'smallInverse', 'space', 'tiny', 'none'])
	};
	
	HLayout.defaultProps = {
	  spacing: 'default'
	};
	
	exports.default = HLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var spinOnYAxis = function spinOnYAxis(times) {
	  return (0, _styledComponents.keyframes)(['0%{transform:rotateY(0);}100%{transform:rotateY(', 'deg);}'], times * 360);
	};
	
	exports.default = spinOnYAxis;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var fixAspectRatio = function fixAspectRatio(width, height) {
	  var ratio = height / width * 100;
	  return (0, _styledComponents.css)(['position:relative;::before{display:block;content:\'\';width:100%;padding-bottom:', '%;}*:first-child{position:absolute;top:0;left:0;right:0;bottom:0;}'], ratio);
	};
	
	exports.default = fixAspectRatio;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _api = __webpack_require__(120);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note: VSCode currently doesn't respect object prop one-liner and removes
	// import, so we need to rename the prop. This is already fixed in the repo and
	// can be removed on next vscode releaase.
	var theme = {
	  api: _api2.default,
	  example: 50,
	  example1: 50,
	  example2: 50,
	  example3: 50,
	  example4: 50,
	  example5: 50
	};
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _graphql = __webpack_require__(58);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _FourOhFourPage = __webpack_require__(505);
	
	var _FourOhFourPage2 = _interopRequireDefault(_FourOhFourPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FourOhFourPage2.default;
	
	// Note: Ideally this would be in its own file and imported from a Page
	// Container, but Gatsby preprocesses the pages looking for a graphql call.
	// Moving it anywhere else results in an error.
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-jsx-0f0a1a9dcbb53a27b9c8.js